var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.headers),function(key,index){return [(key === 'name')?_c('span',{key:index,class:[
                'table__body__row__text position--relative',
                ("table__" + _vm.model + "__col__" + index)
            ]},[_vm._v(" "+_vm._s(_vm.row[key] || '')+" ")]):_vm._e()]}),_c('div',{class:[
            'row__mail-template__actions display--flex',
            ("table__" + _vm.model + "__col__2"),
            { 'row__mail-template__actions--end': _vm.row.enabled || !_vm.$store.getters.can( 'campaign', 'editMailTemplate' ) }
        ]},[(!_vm.row.enabled)?_c('table-actions',{attrs:{"settings":{
                model: 'mailTemplates',
                delete: {
                    action: _vm.deleteMailTemplate
                }
            }}}):_vm._e(),_c('router-link',{staticClass:"table__body__row__icon row__mail-template__anchor position--relative accessibility--button",attrs:{"to":("/campaigns/" + (_vm.$route.params.id) + "/mail-templates/" + (_vm.row.id))}},[_c('icon-info',{staticClass:"row__mail-template__icon"})],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }